exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Banner {\n  margin-bottom: 24px;\n  width: 100%;\n  padding: 16px;\n  border-radius: 3px;\n  float: left;\n  font-size: 16px;\n  background-color: #efefef;\n  color: #676767; }\n  .Banner--Success {\n    background-color: #daf8ca;\n    color: #4f694b; }\n  .Banner--Info {\n    background-color: #cfebef;\n    color: #436d81; }\n  .Banner--Warning {\n    background-color: #f9f0b5;\n    color: #625742; }\n  .Banner--Error {\n    background-color: #f2d9d9;\n    color: #8c3d3d; }\n  .Banner__Message .InputError {\n    font-size: 16px; }\n", ""]);

// exports
